import type { CrmIntegrationProvider } from "app/pages/sales-intelligence/domain/crm-integration/types/provider";

import type { BaseLeadCompanyDataModel } from "../../types/table";
import ExpandedRowTableHeaderBase from "../ExpandedRowTableHeaderBase/ExpandedRowTableHeaderBase";

import HeaderContent from "./HeaderContent";
import { StyledTitleLoader } from "./styles";

type Props = {
    isLoading: boolean;
    companyData: BaseLeadCompanyDataModel;
    integrationProvider: CrmIntegrationProvider;
    matchedCount: number;
    totalCount: number;
    onHide(): void;
};

const CrmRecordsTableHeader = ({
    isLoading,
    companyData,
    integrationProvider,
    matchedCount,
    totalCount,
    onHide,
}: Props) => {
    return (
        <ExpandedRowTableHeaderBase
            companyData={companyData}
            onHide={onHide}
        >
            {isLoading ? (
                <StyledTitleLoader />
            ) : (
                <HeaderContent
                    integrationProvider={integrationProvider}
                    matchedCount={matchedCount}
                    totalCount={totalCount}
                />
            )}
        </ExpandedRowTableHeaderBase>
    );
};

export default CrmRecordsTableHeader;
